import { useAuth } from '@/hooks/use-auth';
import { ExpiredDemoConversionModal } from './ExpiredDemoConversionModal';
import { Loader2 } from 'lucide-react';

interface ExpiredDemoGuardProps {
  children: React.ReactNode;
}

export function ExpiredDemoGuard({ children }: ExpiredDemoGuardProps) {
  const { expiredDemoInfo, checkingDemo, user, loading } = useAuth();

  // Show loading while checking demo status
  if (loading || (user && checkingDemo)) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  // If user has expired demo, show conversion modal (blocks everything)
  if (user && expiredDemoInfo?.is_expired_demo) {
    console.log('🚨 [ExpiredDemoGuard] Blocking access, showing conversion modal');
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <ExpiredDemoConversionModal
          open={true}
          onOpenChange={() => {}} // Can't close modal
          demoCompanyId={expiredDemoInfo.demo_company_id!}
          userEmail={user.email!}
        />
      </div>
    );
  }

  // If everything is OK, render children
  return <>{children}</>;
}
